import View from '../../../../../components/configPdf/View'
import { Page, Document, PDFViewer, Image } from '@react-pdf/renderer'
import config from '../../../../../config.json'
import Text from '../../../../../components/configPdf/Text'
import Text3 from '../../../../../components/configPdf/Text3'
import { listToString } from '../../../../../utils/dataValidations'
import NotaProductoPdfTable from './NotaProductoPdfTable'

// encargado_nombres viene como "3002 - Calixto Garcia..." (el código lo agrega el mapper del
// backend para otras pantallas donde sí sirve) — acá en la nota impresa no aporta nada, se recorta.
const quitarCodigo = (texto) => String(texto || '').replace(/^[^-]*-\s*/, '')

// Ya no busca datos: el paso de ajuste de estados (AlmacenNotaAjusteEstados) es quien llama al
// backend y arma "notas" con los productos + el reparto de estados ya cargado a mano. Este
// componente solo renderiza.
//
// Estilo calcado de la boleta física real de SARI Distribuidora: encabezado limpio sin cajas
// (logo + título + N° en rojo), fecha y nombre del vendedor como líneas subrayadas (no celdas con
// borde completo), tabla con grilla completa (igual que el papel), firmas como línea + etiqueta,
// sin recuadro alrededor.
const NotaEntregaProductoPdf = ({
  orientation,
  data,
  notas = [],
}) => {
  const MyDoc = (
    <Document>
      <Page size='A4' orientation={orientation} style={{ padding: '0px 6px' }}>
        {notas.map((nota, index) => (
          <View
            key={index}
            width='100%'
            flexDirection='column'
            margin='14px 0px 13px 0px'
            border={{ left: true, top: true, right: true, bottom: true }}
            padding='10px'
          >
            <View width='100%' alignItems='center'>
              <View width='30%' alignItems='flex-start' justifyContent='center'>
                <View width='65%'>
                  <Image src={window.location.origin + config.logoPdf} />
                </View>
              </View>
              <View width='40%' alignItems='center' justifyContent='center' flexDirection='column'>
                <Text fontSize='13px' bold>NOTA ENTREGA</Text>
                <Text fontSize='13px' bold>DE PRODUCTO</Text>
              </View>
              <View width='30%' alignItems='flex-end' justifyContent='center'>
                <Text3 bold style={{ color: 'red', fontSize: '11px' }}>N° {nota?.boleta}</Text3>
              </View>
            </View>

            <View width='100%' margin='10px 0 0 0' alignItems='flex-end'>
              <View width='16%'>
                <Text3 bold textAlign='left'>FECHA:</Text3>
              </View>
              <View width='84%' border={{ bottom: true }}>
                <Text3 textAlign='left'>{data?.fecha_salida}</Text3>
              </View>
            </View>
            <View width='100%' margin='6px 0 0 0' alignItems='flex-end'>
              <View width='26%'>
                <Text3 bold textAlign='left'>NOMBRE VENDEDOR:</Text3>
              </View>
              <View width='74%' border={{ bottom: true }}>
                <Text3 textAlign='left'>
                  {listToString([quitarCodigo(nota?.receptor?.encargado_nombres), nota?.receptor?.encargado_apellido_paterno, nota?.receptor?.encargado_apellido_materno], ' ')}
                </Text3>
              </View>
            </View>

            <View margin='10px 0 0 0'>
              <NotaProductoPdfTable productos={nota?.productos} />
            </View>

            <View margin='6px 0 0 0'>
              <View justifyContent='center' width='100%' style={{ backgroundColor: '#eef1f8' }}>
                <Text3 bold={true}>
                  
                Nota: Antes de proceder con el cargado de producto, el envase debe ser revisado minuciosamente. En caso de
que se detecte alguna fisura o defecto, deberá ser reportado inmediatamente a la encargada correspondiente.
Si no se realiza dicho reporte, cualquier inconveniente posterior será bajo su responsabilidad.
                </Text3>
              </View>
            </View>

            <View margin='40px 0 0 0' justifyContent='space-around'>
              <View width='38%' flexDirection='column' alignItems='center'>
                <View width='90%' border={{ bottom: true }} style={{ height: '22px' }} />
                <Text3 bold>ENTREGUÉ CONFORME</Text3>
                <View width='100%' margin='4px 0 0 0'>
                  <Text3 textAlign='left'>Nombre: </Text3>
                </View>
              </View>
              <View width='38%' flexDirection='column' alignItems='center'>
                <View width='90%' border={{ bottom: true }} style={{ height: '22px' }} />
                <Text3 bold>RECIBÍ CONFORME</Text3>
                <View width='100%' margin='4px 0 0 0'>
                  <Text3 textAlign='left'>Nombre: </Text3>
                </View>
              </View>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  )

  return (
    <PDFViewer
      style={{
        width: orientation === 'landscape' ? 1200 : 900,
        height: window.innerHeight - 100,
      }}
      children={MyDoc}
    />
  )
}

export default NotaEntregaProductoPdf
